import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";
import {useNavigate} from "react-router-dom";



const PreSaleS2 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const contentHandler = () =>{
        return (
            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.infoWrap}`}>
                    <div className={`${Styles.infoWrapTitle}`}>TIME CAPSULE</div>
                    <ul className={`${Styles.listWrap}`}>
                        <li className={`${Styles.listWrapItem}`}>{t('Токен')}: <span>$TC</span></li>
                        <li className={`${Styles.listWrapItem}`}>{t('Этап')}: <span>{t('Пресейл')}</span></li>
                        <li className={`${Styles.listWrapItem}`}>{t('Аллокация')}: <span>{t('Лимитированная')}</span></li>
                    </ul>
                </div>
                <div className={`${Styles.priceWrap}`}>
                    <div className={`${Styles.priceWrapTitle}`}>{t('Цена')}</div>
                    <div className={`${Styles.price}`}>2 USDT</div>
                    <div className={`${Styles.btnWrap}`}>
                        <CustomBorder corners={{ bottomRight: true, bottomLeft: true }} withHover={true} fill="#36f6ff" cutSize={20}>
                            <button className={`${Styles.btn}`} onClick={()=>{navigate('/sign-in')}}><div>{t('Купить токены')}</div></button>
                        </CustomBorder>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.bgTitle}`}>{t('Предпродажа уже открыта')}</div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxM}`}>
                    <CustomBorder corners={{}} fill="rgba(24, 22, 40, 0.35)">
                        {contentHandler()}
                    </CustomBorder>
                </div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxD}`}>
                    <CustomBorder corners={{ bottomLeft: true, topRight: true }} cutSize={15} fill="rgba(24, 22, 40, 0.35)">
                        {contentHandler()}
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default PreSaleS2;